import {Route} from "react-router";
import {RequireAuth} from "../authentication/routing/RequireAuth";
import {ChatLayout} from "../pages/chat-agent/ChatLayout";
import {ChatPage} from "../pages/chat-agent/ChatPage";
import {routes} from "./routes";

/** Nested chat layout: the sidebar stays mounted across chat routes. */
export const chatRoute = (
    <Route path={routes.chat} element={<RequireAuth><ChatLayout/></RequireAuth>}>
        <Route index element={<ChatPage/>}/>
    </Route>
);
